(function() {
    var InvoiceCostDisplay = function($el) {
        this.$el = $el
        this.$display = $el.find('span')
        this.$field = $el.find('input')
        this.$itemSelect = this.$el.closest('tr').find('.invoice-item-select')
        this.currency = this.$el.data('currency')

        this.$itemSelect.on('value-changed', this.setToSelectCost.bind(this))
        this.$itemSelect.on('is-misc', this.setToNoCost.bind(this))
        this.$itemSelect.on('init', this.setToSelectCost.bind(this))

        return this
    }

    InvoiceCostDisplay.prototype.setToNoCost = function () {
        this.render('0.00')

        return this
    }

    InvoiceCostDisplay.prototype.setToSelectCost = function () {
        var cost = this.$itemSelect.find('option:selected').data('cost')

        if(_.isEmpty(cost)) {
            this.setToNoCost()
        } else {
            this.render(cost)
        }

        return this
    }

    InvoiceCostDisplay.prototype.render = function (cost) {
        this.$display.html(this.currency + cost)
        this.$field.val(cost)

        return this
    }

    var observer = document.getElementById('invoice-item-observer')

    if (observer) {
        $.initialize('.invoice-cost-display', function() {
            new InvoiceCostDisplay($(this))
        }, { target: observer })
    }
})()
